import React from 'react';
import PropTypes from 'prop-types';
import {withRouter, Redirect} from 'react-router';
import queryString from 'query-string';
import {generateRoutePath} from 'epic-common/src/route';
import Message from 'epic-localization/src/client/message/ContextMessage';
import Header from './Header';

class CreateDeviceSelect extends React.Component {
    static propTypes = {
        content: PropTypes.object,
        history: PropTypes.object,
        location: PropTypes.object,
        isLoggedIn: PropTypes.bool,
        redeem: PropTypes.bool,
        title: PropTypes.string
    };

    state = {
        device: 'noop'
    };

    onClick = () => {
        const selectValue = this.state.device;
        if (selectValue.includes('android-')) {
            this.props.history.push(generateRoutePath('/mobile/android'));
        } else {
            this.props.history.push(generateRoutePath('/mobile/ios'));
        }
    };

    handleChange = e => {
        this.setState({device: e.target.value});
    };

    render() {
        const {content, title, isLoggedIn, location, redeem} = this.props;
        const query = queryString.parse(location.search);

        if (!isLoggedIn) {
            query.selectDevice = true;
            if (redeem) {
                return <Redirect to={generateRoutePath(`/mobile/redeem?${queryString.stringify(query)}`)} />;
            }
            return <Redirect to={generateRoutePath(`/mobile/download?${queryString.stringify(query)}`)} />;
        }
        const options = [];
        const devices = content.devices || [];
        for (let x = 0; x < devices.length; x++) {
            const item = devices[x];
            options.push(
                <option key={`option-${x}`} disabled={item.disabled} value={item.platform}>
                    {item.device}
                </option>
            );
        }
        return (
            <div className="device-select">
                <div className="container-fluid content-container">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                <div className="content">
                                    <Header title={title} />
                                    <h2>{content.title}</h2>
                                    <div dangerouslySetInnerHTML={{__html: content.description}} />
                                    <h4>{content.note}</h4>
                                    <select /*eslint-disable-line*/
                                        ref={c => {
                                            this.deviceSelect = c;
                                        }}
                                        id="deviceSelect"
                                        defaultValue={devices[0].device}
                                        className="form-control input-lg"
                                        onChange={this.handleChange}>
                                        {options}
                                    </select>
                                    <button id="fnMobile-deviceSelect" className="btn btn-primary" onClick={this.onClick}>
                                        <Message code="epic.common.select" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="heroes" />
                </div>
            </div>
        );
    }
}

export default withRouter(CreateDeviceSelect);
